const isBrowser = typeof window !== "undefined";
export default function withQueryParams(url) {
  return isBrowser ? `${url}${window.location.search}` : url;
}
